import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ContrastYellow } from '../theme/contrast-yellow.theme';
import { Dark } from '../theme/dark.theme';
import { Light } from '../theme/light.theme';
import { Login } from '../theme/login.theme';
import { Theme } from '../theme/theme.interface';
import { ContrastCream } from '../theme/contrast-cream.theme';
import { ContrastGreen } from '../theme/contrast-green.theme';
import { ContrastPink } from '../theme/contrast-pink.theme';
import { BlueOnWhite } from '../theme/blue-on-white.theme';
import { ContrastBlue } from '../theme/contrast-blue.theme';
import { BlueOnBlack } from '../theme/blue-on-black.theme';
import { YellowOnBlack } from '../theme/yellow-on-black.theme';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
    private active: Theme = Light;
    private availableThemes: Theme[] = [Light, Dark, Login, ContrastYellow, ContrastCream, ContrastGreen, ContrastPink, ContrastBlue, BlueOnWhite, BlueOnBlack, YellowOnBlack];
    public themeChanged = new Subject<void>();

    get isLoginPage(): boolean { return this.router.url === '/login'; }

    constructor(private router: Router) { }

    public init(): void {
        if (this.isLoginPage) {
			this.setActiveTheme(Login);
        } else {
            if (sessionStorage['theme']) {
                switch (sessionStorage['theme']) {
                    case 'Dark':
						this.setActiveTheme(Dark);
                        break;
                    case 'ContrastYellow':
						this.setActiveTheme(ContrastYellow);
						break;
					case 'ContrastCream':
						this.setActiveTheme(ContrastCream);
						break;
					case 'ContrastGreen':
						this.setActiveTheme(ContrastGreen);
						break;
					case 'ContrastPink':
						this.setActiveTheme(ContrastPink);
						break;
					case 'BlueOnWhite':
						this.setActiveTheme(BlueOnWhite);
						break;
					case 'ContrastBlue':
						this.setActiveTheme(ContrastBlue);
						break;
					case 'BlueOnBlack':
						this.setActiveTheme(BlueOnBlack);
						break;
					case 'YellowOnBlack':
						this.setActiveTheme(YellowOnBlack);
						break;
                    default:
						this.setActiveTheme(Light);
                }
            } else {
				this.setActiveTheme(Light);
            }
        }
    }

    public getAvailableThemes(): Theme[] {
        return this.availableThemes;
    }

    public getActiveTheme(): Theme {
        return this.active;
    }

    public isTheme(themeName: string): boolean {
        return this.active.name === themeName;
    }

    public setLoginTheme(): void {
        this.setActiveTheme(Login);
    }

    public isLoginTheme(): boolean {
        return this.active.name === Login.name;
    }

    public setActiveTheme(theme: Theme): void {
        this.active = theme;

        Object.keys(this.active.properties).forEach(property => {
            document.documentElement.style.setProperty(
                property,
                this.active.properties[property]
            );
        });

        this.rememberTheme();
        this.themeChanged.next();
    }

    public setDefaultIfLogIn(): void {
        if (this.active === Login) {
			this.setActiveTheme(Light);
        }
    }

    private rememberTheme(): void {
        sessionStorage['theme'] = this.active.name;
    }
}
